import { useEffect, useMemo, useState } from "react";
import { useRouter } from "next/router";
import {
  getMultipleFilesByOwnerIdentifier,
  updateBidderForEvent,
} from "services";
import { Button } from "../../../shadcn/components/ui/button";
import { Card, CardContent } from "../../../shadcn/components/ui/card";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../shadcn/components/ui/select";
// import CustomMultiplePDFViewer from "../bidder/CustomMultiplePDFViewer";
// import CustomRejectionModal from "../bidder/CustomRejectionModal";
import ConfirmationModal from "./ConfirmationModal";
import { useSelector } from "react-redux";
import { getBidderByUuid, validatePaymentRequest } from "services/bidder";
import { getBidderKycRequestDetail } from "services";
import { Eye, Download } from "lucide-react";
import { DateTime } from "luxon";
import BidderKYCCustomDocViewer from "./BidderKYCCustomDocViewer";
import CustomModalLayoutV2 from "../../../components/bidder/Tabs/auctionFloor/components/CustomModalLayoutV2";
import CustomRejectionStepModel from "../bidder/CustomRejectionStepModel";

export const BankerNotificationDetailsPage2 = (props: any) => {
  const router = useRouter();
  const { id } = router.query;
  const [renderKey, setRenderKey] = useState(0);
  const [allBiddersData, setAllBiddersData] = useState<any[]>([]);
  const [selectedBidderIndex, setSelectedBidderIndex] = useState(0);
  const [bidderData, setBidderData] = useState<any>();
  const [kycFiles, setKycFiles] = useState<any>([]);
  const [showRejectionModal, setShowRejectionModal] = useState(false);
  const [
    showSecondaryBidderRejectionModal,
    setShowSecondaryBidderRejectionModal,
  ] = useState(false);
  const [showDocumentViewModal, setShowDocumentViewModal] = useState(false);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [modelHeading, setModelHeading] = useState("KYC Documents");
  const [approveRemark, setApproveRemark] = useState("");
  const [documentType, setDocumentType] = useState<
    | "id_proof"
    | "address_proof"
    | "name-mismatch-supporting"
    | "emd-receipt"
    | "ar_kyc_doc"
    | "authorization_letters"
    | "other_docs"
  >("id_proof");
  const [documentUrls, setDocumentUrls] = useState<string[]>([]);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const banker = useSelector((state: any) => {
    return state.bankerAuth.user;
  });
  const bank = useSelector((state: any) => {
    return state.bankerAuth.bank;
  });
  const [isLoading, setIsLoading] = useState(false);
  const shouldShowApproverDetails = useMemo(() => {
    const bankName = String(bank?.name || "")
      .trim()
      .toLowerCase();
    return bankName.includes("icici");
  }, [bank?.name]);

  const handleViewDocuments = async (
    type:
      | "id_proof"
      | "address_proof"
      | "kyc-supporting-documents"
      | "emd-receipt"
      | "ar_kyc_doc"
      | "authorization_letters"
      | "other_docs",
  ) => {
    let urls = [];
    if (type === "address_proof") {
      urls = bidderData?.address_proof_docs.map((file: any) => file);
      setModelHeading("Address Proof Documents");
    } else if (type === "id_proof") {
      urls = bidderData.id_proof_docs?.map((file: any) => file);
      setModelHeading("ID Proof Documents");
    } else if (type === "kyc-supporting-documents") {
      urls = bidderData?.name_mismatch_docs?.map((file: any) => file);
      setModelHeading("Name Mismatch Supporting Documents");
    } else if (type === "emd-receipt") {
      urls = bidderData.emd_payment_docs?.map((file: any) => file);
      setModelHeading("EMD Payment Proof");
    } else if (type === "ar_kyc_doc") {
      urls = bidderData.ar_docs?.map((file: any) => file);
      setModelHeading("AR KYC Documents");
    } else if (type === "authorization_letters") {
      urls = bidderData.ar_authorization_letter_docs?.map((file: any) => file);
      setModelHeading("AR Authorization Letters");
    } else if (type === "other_docs") {
      urls = bidderData.additional_docs?.map((file: any) => file);
      setModelHeading("Additional Documents");
    }

    setDocumentUrls(urls);
    setShowDocumentViewModal(true);
  };
  const handleDownloadDocuments = async (
    type:
      | "address_proof"
      | "id_proof"
      | "kyc-supporting-documents"
      | "emd-receipt"
      | "ar_kyc_doc"
      | "authorization_letters"
      | "other_docs",
  ) => {
    let urls = [];
    if (type === "address_proof") {
      urls = bidderData?.address_proof_docs.map((file: any) => file);
      setDocumentType("address_proof");
      setModelHeading("Address Proof Documents");
    } else if (type === "id_proof") {
      urls = bidderData.id_proof_docs?.map((file: any) => file);
      setDocumentType("id_proof");
      setModelHeading("ID Proof Documents");
    } else if (type === "kyc-supporting-documents") {
      urls = bidderData?.name_mismatch_docs?.map((file: any) => file);
      setDocumentType("name-mismatch-supporting");
      setModelHeading("Name Mismatch Supporting Documents");
    } else if (type === "emd-receipt") {
      urls = bidderData.emd_payment_docs?.map((file: any) => file);
      setDocumentType("emd-receipt");
      setModelHeading("EMD Payment Proof");
    } else if (type === "ar_kyc_doc") {
      urls = bidderData.ar_docs?.map((file: any) => file);
      setDocumentType("ar_kyc_doc");
      setModelHeading("AR KYC Documents");
    } else if (type === "authorization_letters") {
      urls = bidderData.ar_authorization_letter_docs?.map((file: any) => file);
      setDocumentType("authorization_letters");
      setModelHeading("AR Authorization Letters");
    } else if (type === "other_docs") {
      urls = bidderData.additional_docs?.map((file: any) => file);
      setDocumentType("other_docs");
      setModelHeading("Additional Documents");
    }
    //authorization_letters
    setDocumentUrls(urls);
    setIsDownloadModalOpen(true);
  };

  useEffect(() => {
    (async () => {
      const allBidderData: any = await getBidderKycRequestDetail(id);
      console.log("func run", allBidderData);

      // Store all bidders data
      setAllBiddersData(allBidderData || []);

      // Set primary bidder (first one) as default
      if (allBidderData && allBidderData.length > 0) {
        setSelectedBidderIndex(0);
        setBidderData(allBidderData[0]);

        if (allBidderData[0]) {
          const kycData: any = await getMultipleFilesByOwnerIdentifier(
            allBidderData[0]?.uuid,
            allBidderData[0]?.created_by === "banker"
              ? "kyc-documents"
              : "signed-bid-request-agreement",
          );

          if (kycData) {
            const filteredKycdata = kycData?.map((item: any) => ({
              id: item?.uuid,
              mime: item?.mime,
              filename: item?.file_name,
            }));
            setKycFiles(filteredKycdata);
            setRenderKey((prev) => prev + 1);
          }
        }
      }
    })();
  }, [id]);

  // Update bidder data when selected index changes
  useEffect(() => {
    if (
      allBiddersData &&
      allBiddersData.length > 0 &&
      allBiddersData[selectedBidderIndex]
    ) {
      const selectedBidder = allBiddersData[selectedBidderIndex];
      setBidderData(selectedBidder);

      // Fetch KYC files for selected bidder
      (async () => {
        const kycData: any = await getMultipleFilesByOwnerIdentifier(
          selectedBidder?.uuid,
          selectedBidder?.created_by === "banker"
            ? "kyc-documents"
            : "signed-bid-request-agreement",
        );

        if (kycData) {
          const filteredKycdata = kycData?.map((item: any) => ({
            id: item?.uuid,
            mime: item?.mime,
            filename: item?.file_name,
          }));
          setKycFiles(filteredKycdata);
          setRenderKey((prev) => prev + 1);
        }
      })();
    }
  }, [selectedBidderIndex, allBiddersData]);

  const handleAcceptEvent = async () => {
    try {
      const payload: any = {
        uuid: id,
        status: "verified",
        kyc_verified: true,
        emd_amount_paid: true,
        agreement_signed: true,
        application_form_filled: true,
      };
      if (approveRemark) {
        payload["remarks"] = approveRemark;
      }
      const data: any = await updateBidderForEvent(payload);
      setApproveRemark("");
      router.back();
    } catch (err) {
      console.log("error", err);
    }
  };
  const handleBidderKYCApprovalEvent = async (bidderUuid: string) => {
    try {
      const data: any = await updateBidderForEvent({
        uuid: bidderUuid,
        status: "verified",
        kyc_verified: true,
        emd_amount_paid: true,
        agreement_signed: true,
        application_form_filled: true,
      });
      router.back();
    } catch (err) {
      console.log("error", err);
    }
  };

  const handleSecondaryBidderRejectEvent = async (
    cancellationReason: string,
    selectedReasons: any,
  ) => {
    try {
      if (!selectedBidderIndex || selectedBidderIndex === 0) return;
      const selectedBidder = allBiddersData[selectedBidderIndex];
      if (!selectedBidder?.uuid) return;

      setIsLoading(true);
      const bidderData: any = await getBidderByUuid(selectedBidder.uuid);
      const kycMode = bidderData?.meta?.bid_application_flow_mode || "online";
      const isJoint = bidderData?.is_joint || false;
      const userType =
        bidderData?.meta?.user_details?.user_type?.value === "individual"
          ? "individual"
          : "non-individual";

      const updatePayload: any = {
        uuid: selectedBidder.uuid,
        status: "rejected",
        verification_step: "rejected",
        remarks: cancellationReason,
      };

      // Ensure selectedReasons is an array
      const reasonsArray = Array.isArray(selectedReasons)
        ? selectedReasons
        : [];

      // Helper function to update steps_status and esigned_data
      const updateStepsAndEsigned = (
        rejectedSteps: string[],
        existingMeta?: any,
        existingEsignedData?: any,
      ) => {
        const stepsStatus: Record<string, string> = {
          ...existingMeta?.steps_status,
        };
        rejectedSteps.forEach((step) => {
          stepsStatus[step] = "rejected";
        });

        updatePayload["meta"] = {
          ...existingMeta,
          steps_status: stepsStatus,
        };

        if (existingEsignedData) {
          updatePayload["esigned_data"] = {
            old_esigned_data: {
              ...existingEsignedData,
            },
          };
        }
      };

      // Handle EMD rejection (applies to all types)
      if (reasonsArray.includes("emd_rejection")) {
        updatePayload["payment_data"] = {
          ...bidderData.payment_data,
          form_submission: "rejected",
          reject_remarks: cancellationReason,
          verification_step: "emd_rejection",
        };
      }

      // Handle Individual KYC rejections
      if (userType === "individual" && isJoint !== true) {
        // Collect all rejected steps for individual offline
        const rejectedStepsSet = new Set<string>();
        let hasAnyRejection = false;

        if (reasonsArray.includes("kyc_rejection")) {
          if (kycMode === "online") {
            // Online KYC – replace any existing kyc_data with a clean rejected object
            updatePayload["kyc_data"] = {
              verification_status: "rejected",
              status: "rejected",
              reject_remarks: cancellationReason,
              verification_step: "kyc_rejection",
            };
          } else {
            // Offline KYC – preserve existing kyc_data and override rejection-related fields
            updatePayload["kyc_data"] = {
              ...bidderData.kyc_data,
              verification_status: "rejected",
              status: "rejected",
              reject_remarks: cancellationReason,
              verification_step: "kyc_rejection",
            };
          }
          rejectedStepsSet.add("offline_kyc");
          rejectedStepsSet.add("bid_application_download");
          rejectedStepsSet.add("completed");
          hasAnyRejection = true;
        }

        if (reasonsArray.includes("bid_application_data_issue")) {
          updatePayload["application_form_data"] = {
            ...bidderData.application_form_data,
            status: "rejected",
            reject_remarks: cancellationReason,
            verification_step: "bid_application_data_issue",
          };
          rejectedStepsSet.add("bid_details");
          rejectedStepsSet.add("bid_application_download");
          rejectedStepsSet.add("completed");
          hasAnyRejection = true;
        }

        // Update all rejected steps at once
        if (hasAnyRejection) {
          updateStepsAndEsigned(
            Array.from(rejectedStepsSet),
            bidderData?.meta,
            bidderData?.esigned_data,
          );
        }
      }

      // Handle Non-Individual KYC rejections (both online and offline)
      if (userType === "non-individual") {
        // Collect all rejected steps for non-individual
        const rejectedStepsSet = new Set<string>();
        let hasAnyRejection = false;

        if (reasonsArray.includes("business_entity_rejection")) {
          updatePayload["kyc_data"] = {
            ...bidderData.kyc_data,
            status: "rejected",
            reject_remarks: cancellationReason,
            verification_step: "business_entity_rejection",
          };
          rejectedStepsSet.add("business_details");
          rejectedStepsSet.add("bid_application_download");
          rejectedStepsSet.add("completed");
          hasAnyRejection = true;
        }

        if (reasonsArray.includes("add_ar_rejection")) {
          updatePayload["application_form_data"] = {
            ...bidderData.application_form_data,
            ar_details: {
              ...bidderData.application_form_data?.ar_details,
              status: "rejected",
              reject_remarks: cancellationReason,
              verification_step: "add_ar_rejection",
            },
            ar_doc_details: {
              ...bidderData.application_form_data?.ar_doc_details,
              status: "rejected",
              reject_remarks: cancellationReason,
              verification_step: "add_ar_rejection",
            },
            ar_step: "",
          };
          rejectedStepsSet.add("add_ar");
          rejectedStepsSet.add("ar_declaration");
          rejectedStepsSet.add("bid_application_download");
          rejectedStepsSet.add("completed");
          hasAnyRejection = true;
        }

        if (reasonsArray.includes("bid_application_data_issue")) {
          updatePayload["application_form_data"] = {
            ...bidderData.application_form_data,
            status: "rejected",
            reject_remarks: cancellationReason,
            verification_step: "bid_application_data_issue",
          };
          rejectedStepsSet.add("bid_details");
          rejectedStepsSet.add("bid_application_download");
          rejectedStepsSet.add("completed");
          hasAnyRejection = true;
        }

        // Update all rejected steps at once
        if (hasAnyRejection) {
          updateStepsAndEsigned(
            Array.from(rejectedStepsSet),
            bidderData?.meta,
            bidderData?.esigned_data,
          );
        }
      }

      // Handle Joint Individual KYC rejections
      if (userType === "individual" && isJoint === true) {
        const rejectedStepsSet = new Set<string>();
        let hasAnyRejection = false;

        if (reasonsArray.includes("kyc_rejection")) {
          if (kycMode === "online") {
            updatePayload["kyc_data"] = {
              verification_status: "rejected",
              status: "rejected",
              reject_remarks: cancellationReason,
              verification_step: "kyc_rejection",
            };
          } else {
            updatePayload["kyc_data"] = {
              ...bidderData.kyc_data,
              verification_status: "rejected",
              status: "rejected",
              reject_remarks: cancellationReason,
              verification_step: "kyc_rejection",
            };
          }
          rejectedStepsSet.add("offline_kyc");
          rejectedStepsSet.add("bid_application_download");
          rejectedStepsSet.add("completed");
          hasAnyRejection = true;
        }

        if (reasonsArray.includes("bid_application_data_issue")) {
          updatePayload["application_form_data"] = {
            ...bidderData.application_form_data,
            status: "rejected",
            reject_remarks: cancellationReason,
            verification_step: "bid_application_data_issue",
          };
          rejectedStepsSet.add("bid_details");
          rejectedStepsSet.add("bid_application_download");
          rejectedStepsSet.add("completed");
          hasAnyRejection = true;
        }

        if (hasAnyRejection) {
          updateStepsAndEsigned(
            Array.from(rejectedStepsSet),
            bidderData?.meta,
            bidderData?.esigned_data,
          );
        }
      }

      await updateBidderForEvent(updatePayload);
      setIsLoading(false);
      router.replace("/dashboard/bid-requests");
    } catch (error: any) {
      setIsLoading(false);
      console.log("check here error", error);
    }
  };

  const handleRejectEvent = async (
    cancellationReason: string,
    selectedReasons: any,
  ) => {
    try {
      if (id === "") return;
      setIsLoading(true);
      const bidderData: any = await getBidderByUuid(id);
      const kycMode = bidderData?.meta?.bid_application_flow_mode || "online";
      const isJoint = bidderData?.is_joint || false;
      const userType =
        bidderData?.meta?.user_details?.user_type?.value === "individual"
          ? "individual"
          : "non-individual";

      const updatePayload: any = {
        uuid: id,
        status: "rejected",
        verification_step: "rejected",
        remarks: cancellationReason,
      };

      // Ensure selectedReasons is an array
      const reasonsArray = Array.isArray(selectedReasons)
        ? selectedReasons
        : [];

      // Helper function to update steps_status and esigned_data
      const updateStepsAndEsigned = (
        rejectedSteps: string[],
        existingMeta?: any,
        existingEsignedData?: any,
      ) => {
        const stepsStatus: Record<string, string> = {
          ...existingMeta?.steps_status,
        };
        rejectedSteps.forEach((step) => {
          stepsStatus[step] = "rejected";
        });

        updatePayload["meta"] = {
          ...existingMeta,
          steps_status: stepsStatus,
        };

        if (existingEsignedData) {
          updatePayload["esigned_data"] = {
            old_esigned_data: {
              ...existingEsignedData,
            },
          };
        }
      };

      // Handle EMD rejection (applies to all types)
      if (reasonsArray.includes("emd_rejection")) {
        updatePayload["payment_data"] = {
          ...bidderData.payment_data,
          form_submission: "rejected",
          reject_remarks: cancellationReason,
          verification_step: "emd_rejection",
        };
      }

      // Handle Individual Offline KYC rejections
      if (
        userType === "individual" &&
        isJoint !== true &&
        kycMode === "offline"
      ) {
        // Collect all rejected steps for individual offline
        const rejectedStepsSet = new Set<string>();
        let hasAnyRejection = false;

        if (reasonsArray.includes("kyc_rejection")) {
          updatePayload["kyc_data"] = {
            ...bidderData.kyc_data,
            verification_status: "rejected",
            status: "rejected",
            kyc_verified: false,
            reject_remarks: cancellationReason,
            verification_step: "kyc_rejection",
          };
          rejectedStepsSet.add("offline_kyc");
          rejectedStepsSet.add("bid_application_download");
          rejectedStepsSet.add("completed");
          hasAnyRejection = true;
        }

        if (reasonsArray.includes("bid_application_data_issue")) {
          updatePayload["application_form_data"] = {
            ...bidderData.application_form_data,
            status: "rejected",
            reject_remarks: cancellationReason,
            verification_step: "bid_application_data_issue",
          };
          rejectedStepsSet.add("bid_details");
          rejectedStepsSet.add("bid_application_download");
          rejectedStepsSet.add("completed");
          hasAnyRejection = true;
        }

        // Update all rejected steps at once
        if (hasAnyRejection) {
          updateStepsAndEsigned(
            Array.from(rejectedStepsSet),
            bidderData?.meta,
            bidderData?.esigned_data,
          );
        }
      }

      // Handle Joint Individual KYC rejections
      if (userType === "individual" && isJoint === true) {
        // Use similar logic as individual, but add joint-specific steps
        const rejectedStepsSet = new Set<string>();
        let hasAnyRejection = false;

        if (reasonsArray.includes("kyc_rejection")) {
          if (kycMode === "online") {
            // Online joint KYC – replace existing kyc_data with clean rejected object
            updatePayload["kyc_data"] = {
              verification_status: "rejected",
              status: "rejected",
              kyc_verified: false,
              reject_remarks: cancellationReason,
              verification_step: "kyc_rejection",
            };
          } else {
            // Offline joint KYC – preserve existing kyc_data and override rejection fields
            updatePayload["kyc_data"] = {
              ...bidderData.kyc_data,
              verification_status: "rejected",
              status: "rejected",
              kyc_verified: false,
              reject_remarks: cancellationReason,
              verification_step: "kyc_rejection",
            };
          }
          if (kycMode === "online") {
            rejectedStepsSet.add("online_kyc");
            rejectedStepsSet.add("joint_proof");
            rejectedStepsSet.add("e_sign");
            rejectedStepsSet.add("completed");
          } else {
            rejectedStepsSet.add("offline_kyc");
            rejectedStepsSet.add("joint_proof");
            rejectedStepsSet.add("bid_application_download");
            rejectedStepsSet.add("completed");
          }
          hasAnyRejection = true;
        }

        if (reasonsArray.includes("joint_proof_rejection")) {
          updatePayload["kyc_data"] = {
            ...bidderData.kyc_data,
            verification_status: "rejected",
            status: "rejected",
            reject_remarks: cancellationReason,
            verification_step: "joint_proof_rejection",
          };
          rejectedStepsSet.add("joint_proof");
          rejectedStepsSet.add("bid_application_download");
          rejectedStepsSet.add("completed");
          hasAnyRejection = true;
        }

        if (reasonsArray.includes("bid_application_data_issue")) {
          updatePayload["application_form_data"] = {
            ...bidderData.application_form_data,
            status: "rejected",
            reject_remarks: cancellationReason,
            verification_step: "bid_application_data_issue",
          };
          rejectedStepsSet.add("bid_details");
          rejectedStepsSet.add("bid_application_download");
          rejectedStepsSet.add("completed");
          hasAnyRejection = true;
        }

        // For online mode, always add e_sign if any step is rejected
        if (hasAnyRejection && kycMode === "online") {
          rejectedStepsSet.add("e_sign");
        }

        // Update all rejected steps at once
        if (hasAnyRejection) {
          updateStepsAndEsigned(
            Array.from(rejectedStepsSet),
            bidderData?.meta,
            bidderData?.esigned_data,
          );
        }
      }

      // Handle Non-Individual KYC rejections (both online and offline)
      if (userType === "non-individual") {
        // Collect all rejected steps for non-individual
        const rejectedStepsSet = new Set<string>();
        let hasAnyRejection = false;

        if (reasonsArray.includes("business_entity_rejection")) {
          updatePayload["kyc_data"] = {
            ...bidderData.kyc_data,
            status: "rejected",
            reject_remarks: cancellationReason,
            verification_step: "business_entity_rejection",
          };
          rejectedStepsSet.add("business_details");
          rejectedStepsSet.add("bid_application_download");
          rejectedStepsSet.add("completed");
          hasAnyRejection = true;
        }

        if (reasonsArray.includes("add_ar_rejection")) {
          updatePayload["application_form_data"] = {
            ...bidderData.application_form_data,
            ar_details: {
              ...bidderData.application_form_data?.ar_details,
              status: "rejected",
              reject_remarks: cancellationReason,
              verification_step: "add_ar_rejection",
            },
            ar_doc_details: {
              ...bidderData.application_form_data?.ar_doc_details,
              status: "rejected",
              reject_remarks: cancellationReason,
              verification_step: "add_ar_rejection",
            },
            ar_step: "",
          };
          rejectedStepsSet.add("add_ar");
          rejectedStepsSet.add("ar_declaration");
          rejectedStepsSet.add("bid_application_download");
          rejectedStepsSet.add("completed");
          hasAnyRejection = true;
        }

        if (reasonsArray.includes("bid_application_data_issue")) {
          updatePayload["application_form_data"] = {
            ...bidderData.application_form_data,
            status: "rejected",
            reject_remarks: cancellationReason,
            verification_step: "bid_application_data_issue",
          };
          rejectedStepsSet.add("bid_details");
          rejectedStepsSet.add("bid_application_download");
          rejectedStepsSet.add("completed");
          hasAnyRejection = true;
        }

        // Update all rejected steps at once
        if (hasAnyRejection) {
          updateStepsAndEsigned(
            Array.from(rejectedStepsSet),
            bidderData?.meta,
            bidderData?.esigned_data,
          );
        }
      }

      await updateBidderForEvent(updatePayload);
      setIsLoading(false);
      router.replace("/dashboard/bid-requests");
    } catch (error: any) {
      setIsLoading(false);
      console.log("check here error", error);
    }
  };

  const handleEMDPaymentAcceptAction = async (
    type: "approved" | "rejected",
  ) => {
    try {
      if (type === "approved") {
        const payload = {
          event_uuid: bidderData?.event_uuid,
          approver_user_uuid: banker.uuid,
          approver_email: banker?.attributes?.find(
            (a: any) => a.type === "email",
          )?.value,
          action_by: "banker",
          approver_name: banker?.profile?.bio?.full_name,
          bidder_uuid: bidderData.uuid,
          approval_status: "approved",
          remarks: "",
        };
        await validatePaymentRequest(payload);
      }
      if (type === "rejected") {
        const payload = {
          event_uuid: bidderData?.event_uuid,
          approver_user_uuid: banker.uuid,
          approver_email: banker?.attributes?.find(
            (a: any) => a.type === "email",
          )?.value,
          action_by: "banker",
          approver_name: banker?.profile?.bio?.full_name,
          bidder_uuid: bidderData.uuid,
          approval_status: "rejected",
          remarks: "",
        };
        await validatePaymentRequest(payload);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const formatDate = (date?: string | null) => {
    if (!date) return "N/A";
    let dt = DateTime.fromISO(date);
    if (!dt.isValid) {
      dt = DateTime.fromFormat(date, "d MMMM yyyy 'at' h:mm a");
    }
    if (!dt.isValid) {
      return date;
    }
    return dt.setZone("Asia/Kolkata").toFormat("dd MMMM yyyy hh:mm a");
  };

  const getStatusBadge = () => {
    const status = bidderData?.status;
    if (status === "pending")
      return (
        <span className="status-pill status-pending inline-block text-xs px-2 py-1 rounded-full bg-[#fff3e5] text-[#b14b00]">
          Pending
        </span>
      );
    if (status === "verified" || status === "completed")
      return (
        <span className="status-pill status-completed inline-block text-xs px-2 py-1 rounded-full bg-[#e6f7ea] text-[#1a7f3a]">
          Completed
        </span>
      );
    if (status === "rejected")
      return (
        <span className="status-pill status-rejected inline-block text-xs px-2 py-1 rounded-full bg-[#fff1f1] text-[#a12b2b]">
          Rejected
        </span>
      );
    return null;
  };

  // const maskEmail = (email: string) => {
  //   if (!email) return "";
  //   const parts = email.split("@");
  //   const local = parts[0];
  //   const domain = parts[1] || "";
  //   return local.slice(0, 1) + `*****${local.slice(-1)}@` + domain;
  // };
  const maskEmail = (email: any) => {
    if (!email) return "";
    const [local, domain] = email.split("@");
    if (!local || !domain) return "";

    // Mask local part: show middle character with asterisks before and after
    // Format: ***v**** (3+ asterisks, middle char, 4+ asterisks)
    let maskedLocal = "***";
    if (local.length > 2) {
      const middleIndex = Math.floor(local.length / 2);
      maskedLocal = `***${local[middleIndex]}***`;
    } else if (local.length > 0) {
      maskedLocal = "***";
    }

    // Mask domain part: show middle character of domain name, mask rest, then show TLD
    // Format: ***i***.com (3+ asterisks, middle char, 3+ asterisks, TLD)
    const [domainName, ...tldParts] = domain.split(".");
    const tld = tldParts.length > 0 ? `.${tldParts.join(".")}` : "";
    let maskedDomain = "***";
    if (domainName.length > 2) {
      const middleIndex = Math.floor(domainName.length / 2);
      maskedDomain = `***${domainName[middleIndex]}***${tld}`;
    } else if (domainName.length > 0) {
      maskedDomain = `***${tld}`;
    }
    return `${maskedLocal}@${maskedDomain}`;
  };

  const maskPhone = (phone: string) => {
    if (!phone) return "";
    return "+91" + phone.slice(0, 1) + "********" + phone.slice(-1);
  };
  const maskName = (name: string) => {
    if (!name || name.length === 0) return "";
    if (name.length <= 2) return name.charAt(0) + "***";
    return name.charAt(0) + "**********" + name.charAt(name.length - 1);
  };
  const maskPan = (pan: any) => {
    if (!pan) return "";
    const panStr = String(pan).toUpperCase();
    if (panStr.length < 4) return "****";
    if (panStr.length <= 4) return panStr.slice(0, 2) + "**";
    const first2 = panStr.slice(0, 1);
    const last2 = panStr.slice(-1);
    return `${first2}********${last2}`;
  };

  if (!bidderData) {
    return (
      <div className="flex items-center justify-center py-12">
        <p className="text-gray-500">Loading...</p>
      </div>
    );
  }

  // Check if should show dropdown: primary bidder is_joint is true and all bidders have is_joint true
  const shouldShowDropdown =
    allBiddersData.length > 1 &&
    allBiddersData[0]?.is_joint === true &&
    allBiddersData.every((bidder) => bidder?.is_joint === true);

  return (
    <>
      <div className="w-full px-4 lg:px-8 mt-5 pb-4">
        {/* Header Section */}
        <div className="flex flex-col justify-between items-center mb-2.5 sm:flex-row gap-6 sm:gap-0">
          <div>
            <div className="text-lg font-bold text-gray-800">
              Verify KYC & EMD:{" "}
              <span className="text-brand-orange">
                {bidderData?.user_type === "individual"
                  ? "Individual"
                  : "Non-individual"}
              </span>
              {shouldShowDropdown && (
                <span className="text-gray-600 font-normal">
                  {" "}
                  ({selectedBidderIndex === 0 ? "Primary" : "Secondary"})
                </span>
              )}
            </div>
            <div className="text-sm text-[#777] mt-0.5">
              Borrower: <span>{bidderData?.borrower_name || ""}</span>
              <span className="ml-2">{getStatusBadge()}</span>
            </div>
          </div>
          <div className="flex gap-2.5">
            <Button
              variant="outline"
              className="bg-transparent border border-[#ddd] text-[#333] rounded-lg px-3.5 py-2 text-xs font-semibold h-auto"
              onClick={() => router.back()}
            >
              ← Back
            </Button>

            <Button
              disabled={bidderData?.status !== "pending" || isLoading}
              onClick={() => {
                if (bidderData?.dd_approval_status === "rejected") {
                  alert(
                    "EMD payment was rejected by the approver. Please contact Auction Bazaar support. You cannot proceed further.",
                  );
                  return;
                }
                if (
                  bidderData?.payment_validation_enabled === true &&
                  bidderData?.dd_approval_status !== "approved"
                ) {
                  alert(
                    "EMD Payment Require Approval. Please review or approve as AO.",
                  );
                  return;
                }
                setShowConfirmationModal(true);
              }}
              className="bg-[#f5761a] hover:bg-[#f5761a]/92 text-white rounded-lg px-3.5 py-2 text-xs font-semibold h-auto"
            >
              Approve
            </Button>
            <Button
              disabled={bidderData?.status !== "pending" || isLoading}
              onClick={() => {
                setShowRejectionModal(true);
              }}
              className="bg-transparent border border-[#c93b3b] text-[#c93b3b] rounded-lg px-3.5 py-2 text-xs font-semibold h-auto hover:bg-transparent"
            >
              Reject
            </Button>
          </div>
        </div>

        {/* Bidder Selection Dropdown - Only show for joint bidders */}
        {shouldShowDropdown && (
          <div className="mb-4">
            <div className="mb-2">
              <label className="text-sm font-medium text-gray-700">
                Select Bidder to View KYC Details
              </label>
            </div>
            <Select
              value={selectedBidderIndex.toString()}
              onValueChange={(value) => setSelectedBidderIndex(parseInt(value))}
            >
              <SelectTrigger className="w-full md:w-[400px] bg-white border border-gray-300">
                <SelectValue>
                  {selectedBidderIndex === 0
                    ? "Primary Bidder – KYC Details"
                    : `Secondary Bidder ${selectedBidderIndex} – KYC Details`}
                </SelectValue>
              </SelectTrigger>
              <SelectContent>
                {allBiddersData.map((bidder, index) => (
                  <SelectItem
                    key={bidder?.uuid || index}
                    value={index.toString()}
                  >
                    {index === 0
                      ? "Primary Bidder – KYC Details"
                      : `Secondary Bidder ${index} – KYC Details`}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}

        {/* Approve/Reject Actions for Joint Bidders - Only show when secondary bidder is selected */}
        {shouldShowDropdown &&
          selectedBidderIndex > 0 &&
          (() => {
            // Get the currently selected secondary bidder
            const selectedBidder = allBiddersData[selectedBidderIndex];
            if (!selectedBidder) return null;

            const isPending = selectedBidder?.status === "pending";
            const isApproved =
              selectedBidder?.status === "verified" ||
              selectedBidder?.status === "completed";

            // If approved, show message instead of buttons
            if (isApproved) {
              return (
                <div className="mb-4 flex items-center justify-center gap-2 rounded-lg shadow-[0_2px_8px_rgba(0,0,0,0.08)] p-[18px] bg-green-50 border border-green-200">
                  <span className="text-sm font-semibold text-green-700">
                    Application Already Approved
                  </span>
                </div>
              );
            }

            // Show approve/reject buttons for pending status
            return (
              <div className="mb-4 flex items-center justify-between gap-2 rounded-lg shadow-[0_2px_8px_rgba(0,0,0,0.08)] p-[18px]">
                <Button
                  disabled={!isPending || isLoading}
                  onClick={async () => {
                    await handleBidderKYCApprovalEvent(selectedBidder?.uuid);
                  }}
                  className="bg-[#f5761a] hover:bg-[#f5761a]/92 text-white rounded-lg px-3.5 py-2 text-xs font-semibold h-auto disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <span className="sm:hidden">
                    Approve S Bidder {selectedBidderIndex}
                  </span>
                  <span className="hidden sm:inline">
                    Approve Secondary Bidder {selectedBidderIndex}
                  </span>
                </Button>
                <Button
                  variant="outline"
                  disabled={!isPending || isLoading}
                  onClick={() => {
                    setShowSecondaryBidderRejectionModal(true);
                  }}
                  className="bg-transparent border border-[#c93b3b] text-[#c93b3b] rounded-lg px-3.5 py-2 text-xs font-semibold h-auto hover:bg-transparent disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <span className="sm:hidden">
                    Reject S Bidder {selectedBidderIndex}
                  </span>
                  <span className="hidden sm:inline">
                    Reject Secondary Bidder {selectedBidderIndex}
                  </span>
                </Button>
              </div>
            );
          })()}

        {/* Main Card Container */}
        <Card className="bg-white rounded-lg shadow-[0_2px_8px_rgba(0,0,0,0.08)] p-[18px]">
          <CardContent className="p-0">
            {/* Two Column Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-6">
              {/* Left Column - auto width based on content, max 560px */}
              {bidderData?.remarks && (
                <div
                  className={`col-span-1 lg:col-span-2 px-1 md:px-4 py-1 border-b mb-2 flex items-center ${
                    bidderData?.status === "verified"
                      ? "bg-green-50 border-green-200"
                      : bidderData?.status === "rejected"
                      ? "bg-red-50 border-red-200"
                      : "bg-white border-brand-borderGrey"
                  }`}
                >
                  <div
                    className={`text-xs lg:text-sm mb-1 ${
                      bidderData?.status === "verified"
                        ? "text-green-700"
                        : bidderData?.status === "rejected"
                        ? "text-red-700"
                        : "text-brand-textBlack"
                    }`}
                  >
                    Remarks: {bidderData?.remarks || ""}
                  </div>
                </div>
              )}
              <div className="bg-white rounded-lg  px-1 md:px-4">
                {/* Bidder Summary */}
                <div className="mb-4.5">
                  <h3 className="text-[15px] font-semibold mb-2">
                    Bidder Summary
                  </h3>
                  <div className="mb-2.5">
                    <div className="text-xs text-[#888] uppercase tracking-wider mb-0.5">
                      Bidder Name
                    </div>
                    <div className="text-sm font-semibold mt-0.5">
                      {maskName(bidderData?.name) || "N/A"}
                    </div>
                  </div>
                  <div className="mb-2.5">
                    <div className="text-xs text-[#888] uppercase tracking-wider mb-0.5">
                      Email
                    </div>
                    <div className="text-sm font-semibold mt-0.5">
                      {maskEmail(bidderData?.email || "")}
                    </div>
                  </div>
                  <div className="mb-2.5">
                    <div className="text-xs text-[#888] uppercase tracking-wider mb-0.5">
                      Contact
                    </div>
                    <div className="text-sm font-semibold mt-0.5">
                      {maskPhone(bidderData?.mobile_number || "")}
                    </div>
                  </div>
                </div>

                {/* Event Details */}
                <div className="mb-4.5">
                  <h3 className="text-[15px] font-semibold mb-2">
                    Event Details
                  </h3>
                  <div className="mb-2.5">
                    <div className="text-xs text-[#888] uppercase tracking-wider mb-0.5">
                      Event ID
                    </div>
                    <div className="text-sm font-semibold mt-0.5">
                      {bidderData?.event_listing_id || "N/A"}
                    </div>
                  </div>
                  <div className="mb-2.5">
                    <div className="text-xs text-[#888] uppercase tracking-wider mb-0.5">
                      Auction Date & Time
                    </div>
                    <div className="text-sm font-semibold mt-0.5">
                      {bidderData?.auction_start_datetime || "N/A"}
                    </div>
                  </div>
                  <div className="mb-2.5">
                    <div className="text-xs text-[#888] uppercase tracking-wider mb-0.5">
                      Last Date for Bid / EMD
                    </div>
                    <div className="text-sm font-semibold mt-0.5">
                      {bidderData?.emd_last_datetime || "N/A"}
                    </div>
                  </div>
                  <div className="mb-2.5">
                    <div className="text-xs text-[#888] uppercase tracking-wider mb-0.5">
                      Submitted On
                    </div>
                    <div className="text-sm font-semibold mt-0.5">
                      {formatDate(bidderData?.submission_time) || "N/A"}
                    </div>
                  </div>
                  <div className="mb-2.5">
                    <div className="text-xs text-[#888] uppercase tracking-wider mb-0.5">
                      Reserve Price
                    </div>
                    <div className="text-sm font-semibold mt-0.5">
                      {bidderData?.reserve_price || "N/A"}
                    </div>
                  </div>
                  <div className="mb-2.5">
                    <div className="text-xs text-[#888] uppercase tracking-wider mb-0.5">
                      EMD Amount
                    </div>
                    <div className="text-sm font-semibold mt-0.5">
                      {bidderData?.emd_amount || "N/A"}
                    </div>
                  </div>
                  {/* <div className="bg-[#fff3e5] p-2 rounded-md text-xs text-[#6b3a00] mt-1.5">
                    <span className="font-semibold">Note:</span>{" "}
                    {bidderData?.note || "N/A"}
                  </div> */}
                </div>

                {/* Audit Log */}
                <div className="mt-2.5">
                  <div className="text-xs font-semibold mb-1 text-[#444]">
                    Audit Log
                  </div>
                  <div className="text-xs text-[#444]">No actions yet.</div>
                </div>
              </div>

              {/* Right Column */}
              <div className="bg-white rounded-lg  px-1 md:px-4">
                {/* KYC Documents */}
                <div className="mb-4.5">
                  <h3 className="text-[15px] font-semibold mb-2">
                    KYC Documents
                  </h3>
                  <div className="text-xs text-brand-textBlack font-semibold mb-2 flex items-center gap-2">
                    <span>Mode Of KYC:</span>
                    <span
                      className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ${
                        bidderData?.mode === "online"
                          ? "bg-[#e7f1ff] text-[#1d4ed8]"
                          : bidderData?.mode === "offline"
                          ? "bg-[#fff4e5] text-[#b25c00]"
                          : "bg-[#f3f4f6] text-[#6b7280]"
                      }`}
                    >
                      {bidderData?.mode
                        ? bidderData.mode.charAt(0).toUpperCase() +
                          bidderData.mode.slice(1)
                        : "N/A"}
                    </span>
                  </div>
                  <div className="text-xs text-[#666] mb-1">
                    KYC Verification:{" "}
                    {bidderData?.kyc_verified
                      ? "Verified"
                      : "Pending verification"}
                  </div>
                  {bidderData?.kyc_verified &&
                    bidderData?.approve_kyc_remarks && (
                      <div className="text-xs text-[#1a7f3a] mb-1">
                        Approver Remarks:{" "}
                        {bidderData?.approve_kyc_remarks || ""}
                      </div>
                    )}
                  {!bidderData?.kyc_verified &&
                    bidderData?.status === "rejected" &&
                    !bidderData?.reject_kyc_remarks && (
                      <div className="text-xs text-[#b00020] mb-1">
                        Approver Reject Remarks :{" "}
                        {bidderData?.reject_kyc_remarks || "N/A"}
                      </div>
                    )}
                  <div className="flex flex-wrap gap-1 mb-1.5">
                    <span
                      className={`inline-flex items-center gap-1 text-xs px-1.5 py-0.5 rounded-full ${
                        bidderData?.kyc_verified
                          ? "bg-[#e6f7ea] text-[#1a7f3a]"
                          : "bg-[#ffe6e6] text-[#b00020]"
                      }`}
                    >
                      <span>{bidderData?.kyc_verified ? "✔" : "⚠"}</span>{" "}
                      {bidderData?.kyc_verified ? "Verified" : "Pending"}
                    </span>
                  </div>
                  {bidderData?.is_name_mismatch ? (
                    <>
                      <div className="text-xs text-[#666] mb-1.5">
                        KYC Alert: Name mismatch between Aadhaar and PAN.
                        Offline{" "}
                        {bidderData?.kyc_verified
                          ? "Verified"
                          : "Pending Approval"}
                        .
                      </div>
                      <div className="text-xs text-[#666] mb-1.5">
                        Reason: {bidderData?.name_mismatch_reason}
                      </div>
                      <div className="flex flex-wrap gap-1 mb-1.5">
                        <span
                          className={`inline-flex items-center gap-1 text-xs px-1.5 py-0.5 rounded-full ${
                            bidderData?.kyc_verified
                              ? "bg-[#e6f7ea] text-[#1a7f3a]"
                              : "bg-[#ffe6e6] text-[#b00020]"
                          }`}
                        >
                          {bidderData?.kyc_verified ? (
                            <span>✔</span>
                          ) : (
                            <span> ⚠</span>
                          )}{" "}
                          Name mismatch:
                          {bidderData?.kyc_verified
                            ? "Verified"
                            : "Pending Approval"}
                        </span>
                      </div>
                      {shouldShowApproverDetails && (
                        <>
                          <div className="text-xs text-[#666] mb-1.5">
                            Under review with{" "}
                            <span className="font-semibold capitalize">
                              {bidderData?.kyc_approver_details?.approver_name}
                            </span>
                            , (Emp ID:{" "}
                            {
                              bidderData?.kyc_approver_details
                                ?.approver_employee_id
                            }
                            ) {bidderData?.kyc_approver_details?.approver_role}{" "}
                            {
                              bidderData?.kyc_approver_details
                                ?.approver_department
                            }
                            .
                          </div>
                          <div className="text-xs text-[#666] mb-1.5">
                            Email:{" "}
                            {bidderData?.kyc_approver_details?.approver_email},
                            Mobile:{" "}
                            {bidderData?.kyc_approver_details?.approver_mobile}
                          </div>
                        </>
                      )}
                      <div className="mt-1.5">
                        <div className="flex justify-between items-center p-2.5 rounded-md bg-[#fbfbfb] mb-2">
                          <div>
                            <div className="font-semibold text-sm">
                              Name Mismatch Declaration
                            </div>
                            <div className="text-xs text-[#777] mt-0.5">
                              Declaration submitted by bidder for KYC name
                              mismatch.
                            </div>
                          </div>
                          <div className="flex items-center gap-1">
                            <button
                              onClick={async () =>
                                await handleViewDocuments(
                                  "kyc-supporting-documents",
                                )
                              }
                              className="w-8 h-8 rounded-full border border-[#ddd] flex items-center justify-center bg-white hover:bg-[#fafafa]"
                            >
                              <Eye className="h-4 w-4" />
                            </button>
                            <button
                              onClick={async () =>
                                await handleDownloadDocuments(
                                  "kyc-supporting-documents",
                                )
                              }
                              className="w-8 h-8 rounded-full border border-[#ddd] flex items-center justify-center bg-white hover:bg-[#fafafa] ml-1"
                            >
                              <Download className="h-4 w-4" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div>
                      {bidderData?.mode === "offline" &&
                        shouldShowApproverDetails && (
                          <>
                            <div className="text-xs text-[#666] mb-1.5">
                              Under review with{" "}
                              <span className="font-semibold capitalize">
                                {
                                  bidderData?.kyc_approver_details
                                    ?.approver_name
                                }
                              </span>
                              , (Emp ID:{" "}
                              {
                                bidderData?.kyc_approver_details
                                  ?.approver_employee_id
                              }
                              ){" "}
                              {bidderData?.kyc_approver_details?.approver_role}{" "}
                              {
                                bidderData?.kyc_approver_details
                                  ?.approver_department
                              }
                              .
                            </div>

                            <div className="text-xs text-[#666] mb-1.5">
                              Email:{" "}
                              {bidderData?.kyc_approver_details?.approver_email}
                              , Mobile:{" "}
                              {
                                bidderData?.kyc_approver_details
                                  ?.approver_mobile
                              }
                            </div>
                          </>
                        )}
                    </div>
                  )}
                  {bidderData.id_proof_docs?.length > 0 && (
                    <div className="mt-1.5">
                      <div className="flex justify-between items-center p-2.5 rounded-md bg-[#fbfbfb] mb-2">
                        <div>
                          <div className="font-semibold text-sm">Id Proof</div>
                          <div className="text-xs text-[#777] mt-0.5">
                            Details shown in UI. Full KYC available in PDF.
                          </div>
                        </div>
                        <div className="flex items-center gap-1">
                          <button
                            onClick={async () =>
                              await handleViewDocuments("id_proof")
                            }
                            className="w-8 h-8 rounded-full border border-[#ddd] flex items-center justify-center bg-white hover:bg-[#fafafa]"
                          >
                            <Eye className="h-4 w-4" />
                          </button>
                          <button
                            onClick={async () =>
                              await handleDownloadDocuments("id_proof")
                            }
                            className="w-8 h-8 rounded-full border border-[#ddd] flex items-center justify-center bg-white hover:bg-[#fafafa] ml-1"
                          >
                            <Download className="h-4 w-4" />
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  {bidderData.address_proof_docs?.length > 0 && (
                    <div className="mt-1.5">
                      <div className="flex justify-between items-center p-2.5 rounded-md bg-[#fbfbfb] mb-2">
                        <div>
                          <div className="font-semibold text-sm">
                            Address Proof
                          </div>
                          <div className="text-xs text-[#777] mt-0.5">
                            Masked details shown in UI. Full KYC available in
                            PDF.
                          </div>
                        </div>
                        <div className="flex items-center gap-1">
                          <button
                            onClick={async () =>
                              await handleViewDocuments("address_proof")
                            }
                            className="w-8 h-8 rounded-full border border-[#ddd] flex items-center justify-center bg-white hover:bg-[#fafafa]"
                          >
                            <Eye className="h-4 w-4" />
                          </button>
                          <button
                            onClick={async () =>
                              await handleDownloadDocuments("address_proof")
                            }
                            className="w-8 h-8 rounded-full border border-[#ddd] flex items-center justify-center bg-white hover:bg-[#fafafa] ml-1"
                          >
                            <Download className="h-4 w-4" />
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {bidderData?.user_type !== "individual" &&
                    bidderData?.is_joint !== true && (
                      <div className="mt-1.5">
                        <div className="text-[15px] font-semibold mb-2">
                          Authorised Representative Details
                        </div>
                        <div>
                          <div className="mb-2.5 grid grid-cols-2 gap-y-1">
                            <div className="text-xs text-[#666]">
                              AR Name:{" "}
                              <span className="text-[#888]">
                                {maskName(bidderData?.ar_details?.pan_name)}
                              </span>
                            </div>
                            <div className="text-xs text-[#666]">
                              AR Email:{" "}
                              <span className="text-[#888]">
                                {maskEmail(bidderData?.ar_details?.email)}
                              </span>
                            </div>
                            <div className="text-xs text-[#666]">
                              AR PAN:{" "}
                              <span className="text-[#888]">
                                {maskPan(bidderData?.ar_details?.pan)}
                              </span>
                            </div>
                            <div className="text-xs text-[#666]">
                              AR Mobile:{" "}
                              <span className="text-[#888]">
                                {maskPhone(bidderData?.ar_details?.user_mobile)}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="flex justify-between items-center p-1 rounded-md bg-[#fbfbfb] mb-2">
                          <div>
                            <div className="font-semibold text-sm">
                              AR KYC Documents
                            </div>
                            <div className="text-xs text-[#777] mt-0.5">
                              Masked docs of the Authorised Representative are
                              displayed.
                            </div>
                          </div>
                          <div className="flex items-center gap-1">
                            <button
                              onClick={async () =>
                                await handleViewDocuments("ar_kyc_doc")
                              }
                              className="w-8 h-8 rounded-full border border-[#ddd] flex items-center justify-center bg-white hover:bg-[#fafafa]"
                            >
                              <Eye className="h-4 w-4" />
                            </button>
                            <button
                              onClick={async () =>
                                await handleDownloadDocuments("ar_kyc_doc")
                              }
                              className="w-8 h-8 rounded-full border border-[#ddd] flex items-center justify-center bg-white hover:bg-[#fafafa] ml-1"
                            >
                              <Download className="h-4 w-4" />
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                </div>

                {/* EMD Details */}
                <div className="mb-4.5">
                  <h3 className="text-[15px] font-semibold mb-2">
                    EMD Details
                  </h3>
                  <div className="text-xs text-[#666] mb-1">
                    Payment Mode:{" "}
                    {bidderData?.payment_mode?.includes("online")
                      ? "Online transfer"
                      : "Demand Draft (offline)"}
                  </div>
                  {bidderData.payment_validation_enabled === true ? (
                    <div className="flex flex-wrap gap-1 mb-1.5">
                      <span
                        className={`inline-flex items-center gap-1 text-xs px-1.5 py-0.5 rounded-full ${
                          bidderData?.dd_approval_status === "approved"
                            ? "bg-[#e6f7ea] text-[#1a7f3a]"
                            : bidderData?.dd_approval_status === "rejected"
                            ? "bg-[#ffe6e6] text-[#b00020]"
                            : "bg-[#fff4e5] text-[#b25c00]"
                        }`}
                      >
                        <span>
                          {bidderData?.dd_approval_status === "approved"
                            ? "✔"
                            : bidderData?.dd_approval_status === "rejected"
                            ? "⚠"
                            : "⏳"}
                        </span>{" "}
                        {bidderData?.dd_approval_status || "Submitted"}
                      </span>
                    </div>
                  ) : (
                    <div className="flex flex-wrap gap-1 mb-1.5">
                      <span
                        className={`inline-flex items-center gap-1 text-xs px-1.5 py-0.5 rounded-full bg-[#e6f7ea] text-[#1a7f3a]`}
                      >
                        <span>✔</span> Payment Proof Submitted
                      </span>
                    </div>
                  )}
                  {bidderData?.dd_approver_details?.approver_name && (
                    <div className="text-xs text-[#444] mt-1.5">
                      Receiver:{" "}
                      <span className="font-semibold">
                        {bidderData?.dd_approver_details?.approver_name}
                      </span>{" "}
                      (Emp ID:{" "}
                      {bidderData?.dd_approver_details?.approver_employee_id ||
                        "N/A"}
                      ),{" "}
                      {bidderData?.dd_approver_details?.approver_dept || "N/A"}
                      <br />
                      Email:{" "}
                      {bidderData?.dd_approver_details?.approver_email ||
                        "N/A"}{" "}
                      · Mobile:{" "}
                      {bidderData?.dd_approver_details?.approver_mobile ||
                        "N/A"}
                    </div>
                  )}
                  {bidderData?.emd_amount_paid &&
                    bidderData?.approve_payment_remarks && (
                      <div className="text-xs text-[#1a7f3a] mb-1">
                        Approver Remarks:{" "}
                        {bidderData?.approve_payment_remarks || ""}
                      </div>
                    )}
                  {!bidderData?.emd_amount_paid &&
                    bidderData?.status === "rejected" &&
                    !bidderData?.reject_payment_remarks && (
                      <div className="text-xs text-[#b00020] mb-1">
                        Approver Reject Remarks :{" "}
                        {bidderData?.reject_payment_remarks || ""}
                      </div>
                    )}
                  {/* Only show EMD Receipt UI if there are EMD payment docs */}
                  {bidderData?.emd_payment_docs &&
                    bidderData.emd_payment_docs.length > 0 && (
                      <div className="mt-1.5">
                        <div className="flex justify-between items-center p-2.5 rounded-md bg-[#fbfbfb] mb-2">
                          <div>
                            <div className="font-semibold text-sm">
                              EMD Receipt
                            </div>
                            <div className="text-xs text-[#777] mt-0.5">
                              Proof of EMD payment as submitted by bidder.
                            </div>
                          </div>
                          <div className="flex items-center gap-1">
                            <button
                              onClick={async () =>
                                await handleViewDocuments("emd-receipt")
                              }
                              className="w-8 h-8 rounded-full border border-[#ddd] flex items-center justify-center bg-white hover:bg-[#fafafa]"
                            >
                              <Eye className="h-4 w-4" />
                            </button>
                            <button
                              onClick={async () =>
                                await handleDownloadDocuments("emd-receipt")
                              }
                              className="w-8 h-8 rounded-full border border-[#ddd] flex items-center justify-center bg-white hover:bg-[#fafafa] ml-1"
                            >
                              <Download className="h-4 w-4" />
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  {bidderData.payment_validation_enabled === true &&
                    bidderData?.dd_approval_status === "submitted" && (
                      <div className="flex gap-2.5 py-1">
                        <Button
                          onClick={async () => {
                            await handleEMDPaymentAcceptAction("approved");
                          }}
                          className="flex-1 bg-[#f5761a] hover:bg-[#f5761a]/92 text-white rounded-lg px-3.5 py-2 text-xs font-semibold h-auto"
                        >
                          Approve EMD Payment
                        </Button>
                        <Button
                          variant="outline"
                          onClick={async () => {
                            await handleEMDPaymentAcceptAction("rejected");
                          }}
                          className="flex-1 bg-transparent border border-[#ddd] text-[#333] rounded-lg px-3.5 py-2 text-xs font-semibold h-auto"
                        >
                          Reject EMD Payment
                        </Button>
                      </div>
                    )}
                  {/* <div className="relative p-2 mt-2">
                    <div className="absolute top-2 right-2 flex items-center gap-1">
                      <a
                        href={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${
                          bidderData?.emd_payment_uuid
                        }?dl=demand-draft-${Date.now()}.jpg`}
                        download={`demand-draft-${Date.now()}.jpg`}
                        className="inline-flex text-xs items-center text-[#3b4bd8] hover:underline gap-1"
                      >
                        <Download className="h-3 w-3" />
                        Download
                      </a>
                    </div>
                    <div className="flex justify-center md:justify-end mt-4">
                      <img
                        src={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${bidderData?.emd_payment_uuid}`}
                        alt="Demand Draft"
                        className="w-full h-auto max-h-[370px] min-h-[200px] object-contain"
                      />
                    </div>
                  </div> */}
                </div>
                {bidderData?.ar_authorization_letter_docs &&
                  bidderData?.ar_authorization_letter_docs?.length > 0 && (
                    <div className="mt-1.5">
                      {/* <div className="font-semibold text-sm">
                        Other Documents
                      </div> */}
                      <div className="flex justify-between items-center p-1 rounded-md bg-[#fbfbfb] mb-2">
                        <div>
                          <div className="font-semibold text-sm">
                            Authorization Letters
                          </div>
                          <div className="text-xs text-[#777] mt-0.5">
                            Supporting documents for payment or KYC.
                          </div>
                        </div>
                        <div className="flex items-center gap-1">
                          <button
                            onClick={async () =>
                              await handleViewDocuments("authorization_letters")
                            }
                            className="w-8 h-8 rounded-full border border-[#ddd] flex items-center justify-center bg-white hover:bg-[#fafafa]"
                          >
                            <Eye className="h-4 w-4" />
                          </button>
                          <button
                            onClick={async () =>
                              await handleDownloadDocuments(
                                "authorization_letters",
                              )
                            }
                            className="w-8 h-8 rounded-full border border-[#ddd] flex items-center justify-center bg-white hover:bg-[#fafafa] ml-1"
                          >
                            <Download className="h-4 w-4" />
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                {/*Other docs */}
                {bidderData?.additional_docs &&
                  bidderData?.additional_docs?.length > 0 && (
                    <div className="mt-1.5">
                      {/* <div className="font-semibold text-sm">
                        Other Documents
                      </div> */}
                      <div className="flex justify-between items-center p-1 rounded-md bg-[#fbfbfb] mb-2">
                        <div>
                          <div className="font-semibold text-sm">
                            Other Supporting Documents
                          </div>
                          <div className="text-xs text-[#777] mt-0.5">
                            Supporting documents for payment or KYC.
                          </div>
                        </div>
                        <div className="flex items-center gap-1">
                          <button
                            onClick={async () =>
                              await handleViewDocuments("other_docs")
                            }
                            className="w-8 h-8 rounded-full border border-[#ddd] flex items-center justify-center bg-white hover:bg-[#fafafa]"
                          >
                            <Eye className="h-4 w-4" />
                          </button>
                          <button
                            onClick={async () =>
                              await handleDownloadDocuments("other_docs")
                            }
                            className="w-8 h-8 rounded-full border border-[#ddd] flex items-center justify-center bg-white hover:bg-[#fafafa] ml-1"
                          >
                            <Download className="h-4 w-4" />
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                {/* Bid Form */}
                {bidderData?.bid_form_url && (
                  <div className="mb-4.5">
                    {/* <h3 className="text-[15px] font-semibold mb-2">Bid Form</h3> */}
                    {/* <div className="text-xs text-[#666] mb-1">
                    Sealed bid form. Download enabled only after auction
                    date/time.
                  </div> */}
                    <div className="mt-1">
                      <div className="flex justify-between items-center p-2.5 rounded-md bg-[#fbfbfb]">
                        <div>
                          <div className="font-semibold text-sm">Bid Form</div>
                          {/* <div className="text-xs text-[#777] mt-0.5">
                          Not available before auction.
                        </div> */}
                        </div>
                        <button
                          onClick={() => {
                            const fileUrl = `${bidderData?.bid_form_url}?dl`;
                            const filename = `bid-form-${
                              bidderData?.event_listing_id || "unknown"
                            }.pdf`;

                            const link = document.createElement("a");
                            link.href = fileUrl;
                            link.download = filename;
                            link.style.display = "none";
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                          }}
                          className="w-8 h-8 rounded-full border border-[#ddd] flex items-center justify-center bg-white hover:bg-[#fafafa]"
                        >
                          <Download className="h-4 w-4" />
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {/* Bidder Photo */}
                {/* <div className="mb-4.5">
                  <h3 className="text-[15px] font-semibold mb-2">
                    Bidder Photo
                  </h3>
                  <div className="mt-1 p-2.5 rounded-lg bg-[#fbfbfb] flex gap-3 items-center">
                    <div className="w-[70px] h-[70px] rounded-full bg-gray-200 border-2 border-[#eee] flex-shrink-0"></div>
                    <div className="text-sm">
                      <div className="font-semibold">
                        {bidderData?.bidder_name || "Bidder Selfie"}
                      </div>
                      <div className="text-xs text-[#666] mt-0.5">
                        Selfie captured during bid submission.
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {showConfirmationModal && (
        <ConfirmationModal
          onCancel={() => {
            setShowConfirmationModal(false);
            setApproveRemark("");
          }}
          onApprove={handleAcceptEvent}
          isLoading={isLoading}
          modalType="bidder"
          approveRemark={approveRemark}
          setApproveRemark={setApproveRemark}
        />
      )}
      {showRejectionModal && (
        <CustomRejectionStepModel
          handleSubmit={handleRejectEvent}
          bidderKycType={bidderData?.mode}
          bidderType={bidderData?.user_type}
          onClose={setShowRejectionModal}
          isLoading={isLoading}
          paymentValidation={bidderData?.payment_validation_enabled}
          is_joint={bidderData?.is_joint}
        />
      )}
      {showSecondaryBidderRejectionModal && selectedBidderIndex > 0 && (
        <CustomRejectionStepModel
          handleSubmit={handleSecondaryBidderRejectEvent}
          bidderKycType={allBiddersData[selectedBidderIndex]?.mode}
          bidderType={allBiddersData[selectedBidderIndex]?.user_type}
          onClose={setShowSecondaryBidderRejectionModal}
          isLoading={isLoading}
          paymentValidation={
            allBiddersData[selectedBidderIndex]?.payment_validation_enabled
          }
          isSecondaryBidder={true}
        />
      )}
      {showDocumentViewModal && (
        <BidderKYCCustomDocViewer
          isOpen={showDocumentViewModal}
          onClose={() => setShowDocumentViewModal(false)}
          documentUrls={documentUrls}
          headingText={modelHeading}
        />
      )}
      {isDownloadModalOpen && (
        <DownloadModal
          isDownloadModalOpen={isDownloadModalOpen}
          setIsDownloadModalOpen={setIsDownloadModalOpen}
          kycFiles={documentUrls}
          type={documentType}
          headingText={modelHeading}
        />
      )}
    </>
  );
};

export default BankerNotificationDetailsPage2;
interface DownloadModalProps {
  isDownloadModalOpen: boolean;
  setIsDownloadModalOpen: (value: boolean) => void;
  kycFiles: any[];
  headingText?: string;
  type:
    | "id_proof"
    | "address_proof"
    | "name-mismatch-supporting"
    | "emd-receipt"
    | "ar_kyc_doc"
    | "authorization_letters"
    | "other_docs";
}
const DownloadModal = ({
  isDownloadModalOpen,
  setIsDownloadModalOpen,
  kycFiles,
  type,
  headingText = "Download KYC Documents",
}: DownloadModalProps) => {
  const buildFileUrl = (fileId: string) => {
    return `${fileId}?dl`;
  };
  const handleDownloadFile = (fileId: string, index: number): void => {
    const fileUrl = buildFileUrl(fileId);
    const filename = `${type}-document-${index + 1}`;

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = filename;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <CustomModalLayoutV2
      open={isDownloadModalOpen}
      onClose={() => setIsDownloadModalOpen(false)}
      blurBackground={true}
      className="!w-full mx-2 sm:mx-4 md:mx-6 max-w-md overflow-hidden"
      childrenClassName="p-0 overflow-hidden flex flex-col"
    >
      <div className="flex flex-col max-h-[80vh]">
        {/* Header */}
        <div className="flex items-center justify-between px-4 sm:px-6 pt-4 sm:pt-6 pb-3 sm:pb-4 border-b flex-shrink-0 bg-white">
          <h3 className="text-lg sm:text-xl font-semibold text-brand-textBlack">
            {headingText}
          </h3>
        </div>

        {/* Files List */}
        <div className="flex-1 overflow-y-auto p-4 sm:p-6">
          {kycFiles && kycFiles.length > 0 ? (
            <div className="space-y-3">
              {kycFiles.map((file, index) => {
                const fileId = file;
                return (
                  <div
                    key={index}
                    className="flex items-center justify-between p-3 bg-gray-50 rounded-lg border border-gray-200 hover:bg-gray-100 transition-colors"
                  >
                    <div className="flex items-center gap-3 flex-1 min-w-0">
                      <div className="flex-shrink-0">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-6 w-6 text-brand-headingBlue"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                          />
                        </svg>
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-brand-textBlack truncate">
                          {headingText} {index + 1}
                        </p>
                        {/* <p className="text-xs text-gray-500 truncate">
                          {fileId}
                        </p> */}
                      </div>
                    </div>
                    <Button
                      onClick={() => handleDownloadFile(fileId, index)}
                      className="ml-3 flex-shrink-0"
                      size="sm"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 mr-1"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                        />
                      </svg>
                      Download
                    </Button>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="flex items-center justify-center h-32 text-gray-500">
              <p>No documents available</p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="px-4 sm:px-6 py-3 sm:py-4 border-t bg-white flex-shrink-0">
          <Button
            onClick={() => setIsDownloadModalOpen(false)}
            className="w-full"
            variant="outline"
          >
            Close
          </Button>
        </div>
      </div>
    </CustomModalLayoutV2>
  );
};
